import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EventTrackingService } from '../../../../services/event-tracking.service';
import { OptInModalDisclosureComponent } from './opt-in-modal-disclosure.component';

@Component({
  selector: 'app-opt-in-banner',
  templateUrl: './opt-in-banner.component.html',
  styleUrls: ['./opt-in-banner.component.scss', './styles.scss'],
  standalone: false,
})
export class OptInBannerComponent implements OnInit {
  displayOptInBanner? = true;
  @Input() cid: string;
  @Input() isOffersPage = false;
  @Output() bannerCta = new EventEmitter<boolean>();
  customerPortalDisclosureText = `Exciting news! You can now receive offers that are personalized to
  you. Opt in today.`;

  constructor(
    private readonly dialog: MatDialog,
    private readonly eventTrackingService: EventTrackingService
  ) {}

  closeOptInBanner(status: boolean) {
    let linkType = status ? 'creditProfileAuthorization' : 'exitOptIn';
    let linkText = status ? 'Agree' : 'Exit Banner';
    this.displayOptInBanner = false;
    this.bannerCta.emit(status);
    this.eventTrackingService.trackEnterpriseEvent({
      customerPortalClickLinkText: linkText,
      customerPortalClickLinkType: linkType,
      eventRepo: 'customerPortal',
      eventName: 'linkClick',
      cid: this.cid,
    });
  }

  ngOnInit(): void {
    this.displayOptInBanner = true;
    this.eventTrackingService.trackEnterpriseEvent({
      cid: this.cid,
      eventRepo: 'customerPortal',
      eventName: 'optInDisplayed',
      optInDisplayType: 'banner',
      customerPortalDisclosureText: this.customerPortalDisclosureText,
    });
  }

  disclosureClick() {
    this.dialog.open(OptInModalDisclosureComponent, {
      width: '529px',
      maxHeight: '90vh',
      data: { cid: this.cid },
    });
  }
}
